import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {UserService} from "../service/user.service";
import {UserRole} from "../enums/UserRole";

export const isAuthenticatedGuard: CanActivateFn = (route, state) => {
    const userService = inject(UserService);
    const router = inject(Router);
    const token = userService.token;
    const role = userService.role;

    if (role === UserRole.USER && token !== '') {
        return true;
    }
    else {
      userService.setRedirectUrl(state.url);
      router.navigate(['/login']);
      return false;
    }
};
